import React, { memo } from 'react';
import {
  Box,
  Tooltip,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import {
  AlertCriticalIcon,
  AlertIcon,
  CircleCheckIcon,
} from '@fortress-technology-solutions/fortress-component-library/Icons';
import rentForecastMessages from '../messages';
import { FormattedMessage } from 'react-intl';
import { COMPLIANCE_STATES } from '../constants';
import { AsyncBox } from '@fortress-technology-solutions/fortress-component-library/Molecules';

const Review = (props) => {
  const { complianceItems, isLoading } = props;

  const StateIcons = {
    pass: <CircleCheckIcon color="success" />,
    fail: <AlertIcon color="error" />,
    warning: <AlertCriticalIcon color="warning" />,
  };

  return (
    <AsyncBox
      loading={isLoading}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Box sx={{ width: '100%' }}>
        <Typography variant="titleLarge" my={2} component="div">
          <FormattedMessage {...rentForecastMessages.review} />
        </Typography>
        {complianceItems.map((section) => (
          <Box mb={2}>
            <Typography variant="titleSmall" my={2} fontWeight={500}>
              {section.value}
            </Typography>
            {section.items.map((item, index) => {
              let StateIcon = StateIcons[item.state];
              if (
                item.tooltip &&
                (item.state !== COMPLIANCE_STATES.pass ||
                  item.tooltipOptions?.showForAllStates)
              ) {
                StateIcon = (
                  <Tooltip title={item.tooltip} key={index} variant="light">
                    {StateIcon}
                  </Tooltip>
                );
              }
              const contents = (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  key={index}
                >
                  {StateIcon}
                  <Typography variant="bodyMedium" my={1} ml={1}>
                    {item.value}
                  </Typography>
                </Box>
              );
              return contents;
            })}
          </Box>
        ))}
      </Box>
    </AsyncBox>
  );
};

export default memo(Review);
